import React from "react";

import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { useSoftwarePackages } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { CustomBreadcrumb } from "./CustomBreadcrumb";

interface SoftwarePackageBreadcrumbProps {
  softwarePackageId: string;
}

export const SoftwarePackageBreadcrumb: React.FC<SoftwarePackageBreadcrumbProps> = ({
  softwarePackageId
}) => {
  const softwarePackagesQuery = useSoftwarePackages();

  return (
    <QueryStateIndicator {...softwarePackagesQuery}>
      {softwarePackages => {
        const softwarePackage = softwarePackages.find(
          x => x.id === softwarePackageId
        );

        return (
          <CustomBreadcrumb>
            {softwarePackage?.displayName ?? softwarePackage?.id ?? "..."}
          </CustomBreadcrumb>
        );
      }}
    </QueryStateIndicator>
  );
};
